<div class="es-shell">
  <div class="container">

    <!-- HEADER CARD -->
    <div class="header-card">
      <!-- Linha 1: Voltar + número do pedido -->
      <div class="hc-top">
        <button class="btn-voltar" (click)="onVoltar()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
          Voltar
        </button>
        <div class="hc-top-right">
          <span class="hc-badge">#{{ nunota }}</span>
          <span class="hc-tag-badge" *ngIf="numTag" title="Nº da TAG">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3.24H4a1 1 0 0 0-1 1v5.59a2 2 0 0 0 .59 1.41l9.58 9.59a2 2 0 0 0 2.82 0l4.6-4.6a2 2 0 0 0 0-2.82z"></path><circle cx="7.5" cy="7.5" r="1.5"></circle></svg>
            TAG {{ numTag }}
          </span>
        </div>
      </div>

      <!-- Linha 2: Cliente + Vendedor -->
      <div class="hc-info">
        <div class="hc-cliente" *ngIf="clienteNome">{{ clienteNome }}</div>
        <div class="hc-vendedor" *ngIf="vendedor">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          {{ vendedor }}
        </div>
      </div>

      <!-- Linha 3: Ações -->
      <div class="hc-acoes">
        <button class="btn-dividir" (click)="abrirModalDividir()" title="Dividir separação com outro separador">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
          Dividir
        </button>
        <button class="btn-transferir" (click)="abrirModalTransferir()" title="Transferir separação para outro separador">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>
          Transferir
        </button>
      </div>
    </div>

    <!-- STATES -->
    <div *ngIf="carregando" class="loading-state">
      <app-loading-indicator></app-loading-indicator>
      <span>Carregando itens...</span>
    </div>

    <div *ngIf="erro" class="alert alert-danger">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erro }}
    </div>

    <div *ngIf="erroSalvar" class="alert alert-danger" style="margin-bottom:12px">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erroSalvar }}
    </div>

    <!-- LISTA DE ITENS -->
    <div class="content-card" *ngIf="!carregando && !erro && itensFiltrados.length > 0">

      <!-- Progress -->
      <div class="progress-bar-container">
        <div class="progress-info">
          <span>Seus itens ({{ meusSeparados }}/{{ itensFiltrados.length }})</span>
          <span>{{ progresso }}%</span>
        </div>
        <div class="progress-bg">
          <div class="progress-fill" [style.width]="progresso + '%'"></div>
        </div>
      </div>

      <!-- Abas -->
      <div class="abas-wrap">
        <button class="aba-btn" [class.ativa]="abaAtiva === 'pendentes'" (click)="abaAtiva = 'pendentes'">
          A Separar
          <span class="aba-count" [class.count-alert]="itensPendentes.length > 0">{{ itensPendentes.length }}</span>
        </button>
        <button class="aba-btn" [class.ativa]="abaAtiva === 'separados'" (click)="abaAtiva = 'separados'">
          Já Separados
          <span class="aba-count" [class.count-ok]="itensSeparadosLista.length > 0">{{ itensSeparadosLista.length }}</span>
        </button>
      </div>

      <!-- Aba: A Separar -->
      <div class="itens-list" *ngIf="abaAtiva === 'pendentes'">
        <div class="empty-aba" *ngIf="itensPendentes.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          Todos os itens foram separados!
        </div>
        <div class="item-card" *ngFor="let item of itensPendentes; let i = index" (click)="toggleItem(item)">
          <span class="item-ordem">{{ i + 1 }}</span>
          <div class="checkbox-wrapper">
            <div class="custom-checkbox"></div>
          </div>
          <div class="item-details">
            <div class="item-title-row">
              <h4 *ngIf="item.refforn || item.condicao || item.codprod">
                <span class="pn-label" *ngIf="item.refforn">P/N</span>
                <span *ngIf="item.refforn">{{ item.refforn }}</span>
                <span class="pn-sep" *ngIf="item.refforn && item.condicao"> · </span>
                <span class="pn-label" *ngIf="item.condicao">CD</span>
                <span *ngIf="item.condicao">{{ item.condicao }}</span>
                <span class="pn-sep"> · </span>
                <span class="pn-label">COD</span>
                <span>{{ item.codprod }}</span>
              </h4>
              <h4 *ngIf="!item.refforn && !item.condicao && !item.codprod">{{ item.descricao }}</h4>
              <div class="item-descricao" *ngIf="item.refforn || item.condicao || item.codprod">{{ item.descricao }}</div>
            </div>
            <div class="item-meta">
              <span class="badge qty">Qtde: {{ item.qtd }}</span>
              <span class="badge unit">{{ item.unidade }}</span>
              <span class="badge estoque" *ngIf="item.estoque !== undefined" title="Estoque atual">Estoque: {{ item.estoque }}</span>
              <span class="badge loc" *ngIf="item.local">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                {{ item.local }}
              </span>
            </div>
            <!-- Serial atribuído (mostra sempre que houver dado de serial, independente do
                 tipContest — alguns itens têm Form/Lote E Serial ao mesmo tempo) -->
            <div class="serial-row" *ngIf="item.tipContest === 'E' || item.serialAtribuido">
              <span class="badge serial" *ngIf="item.serialAtribuido">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
                SERIAL: {{ item.serialAtribuido }}
              </span>
              <span class="badge serial serial-pendente" *ngIf="!item.serialAtribuido">SERIAL: não atribuído</span>
              <button class="btn-trocar-serial" (click)="abrirModalTrocarSerial(item, $event)" title="Trocar serial">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>
                Trocar
              </button>
            </div>
            <!-- Form (Lote) atribuído. TIPCONTEST é uma coluna nativa única em TGFPRO
                 (E, L ou N — nunca os dois ao mesmo tempo no mesmo produto). Mas quando
                 um serial é atribuído (SerialRepository), o backend também grava esse
                 mesmo valor em TGFITE.CONTROLE para manter sincronizado — por isso não
                 basta checar "item.controle existe": para não duplicar o SERIAL como se
                 fosse um FORM, só mostra a linha de Form quando o controle for um valor
                 realmente diferente do serial atribuído (Form e Serial genuinamente
                 distintos no mesmo item). -->
            <div class="serial-row" *ngIf="item.tipContest === 'L' || (item.controle && item.controle !== item.serialAtribuido)">
              <span class="badge lote" *ngIf="item.controle && item.controle !== item.serialAtribuido">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path></svg>
                FORM: {{ item.controle }}
              </span>
              <span class="badge lote lote-pendente" *ngIf="!item.controle || item.controle === item.serialAtribuido">FORM: não atribuído</span>
              <button class="btn-trocar-serial btn-trocar-lote" (click)="abrirModalTrocarLote(item, $event)" title="Trocar form">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>
                Trocar
              </button>
            </div>
            <!-- "Item no outro Galpão" -- sinaliza pendência sem travar a fila (equivalente nativo do Sistema Legado). -->
            <button class="btn-item-outro-galpao" (click)="abrirModalPendencia(item, $event)" title="Sinalizar que este item está no outro galpão">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
              Item no outro Galpão
            </button>
          </div>
        </div>
      </div>

      <!-- Aba: Já Separados -->
      <div class="itens-list" *ngIf="abaAtiva === 'separados'">
        <div class="empty-aba" *ngIf="itensSeparadosLista.length === 0">
          Nenhum item separado ainda.
        </div>
        <div class="item-card separado" [class.item-card-pendente]="item.pendente" *ngFor="let item of itensSeparadosLista; let i = index" (click)="toggleItem(item)">
          <span class="item-ordem item-ordem-separado">{{ i + 1 }}</span>
          <div class="checkbox-wrapper">
            <div class="custom-checkbox" *ngIf="!item.pendente">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </div>
            <div class="custom-checkbox custom-checkbox-pendente" *ngIf="item.pendente" title="Aguardando o outro galpão">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path></svg>
            </div>
          </div>
          <div class="item-details">
            <div class="item-title-row">
              <h4 *ngIf="item.refforn || item.condicao || item.codprod">
                <span class="pn-label" *ngIf="item.refforn">P/N</span>
                <span *ngIf="item.refforn">{{ item.refforn }}</span>
                <span class="pn-sep" *ngIf="item.refforn && item.condicao"> · </span>
                <span class="pn-label" *ngIf="item.condicao">CD</span>
                <span *ngIf="item.condicao">{{ item.condicao }}</span>
                <span class="pn-sep"> · </span>
                <span class="pn-label">COD</span>
                <span>{{ item.codprod }}</span>
              </h4>
              <h4 *ngIf="!item.refforn && !item.condicao && !item.codprod">{{ item.descricao }}</h4>
              <div class="item-descricao" *ngIf="item.refforn || item.condicao || item.codprod">{{ item.descricao }}</div>
            </div>
            <div class="item-meta">
              <span class="badge qty">Qtde: {{ item.qtd }}</span>
              <span class="badge unit">{{ item.unidade }}</span>
              <span class="badge estoque" *ngIf="item.estoque !== undefined" title="Estoque atual">Estoque: {{ item.estoque }}</span>
              <span class="badge loc" *ngIf="item.local">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                {{ item.local }}
              </span>
            </div>
            <!-- Item pendente ("Item no outro Galpão") -- badge + Desfazer (sinalização feita por engano). -->
            <div class="serial-row" *ngIf="item.pendente">
              <span class="badge pendente-galpao">Aguardando o outro galpão</span>
              <button class="btn-trocar-serial" (click)="desfazerPendencia(item, $event)" [disabled]="desfazendoPendenciaSeq === item.seq" title="Desfazer sinalização (feita por engano)">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                {{ desfazendoPendenciaSeq === item.seq ? 'Desfazendo...' : 'Desfazer' }}
              </button>
            </div>
            <!-- Serial atribuído (mostra sempre que houver dado de serial, independente do
                 tipContest — alguns itens têm Form/Lote E Serial ao mesmo tempo) -->
            <div class="serial-row" *ngIf="item.tipContest === 'E' || item.serialAtribuido">
              <span class="badge serial" *ngIf="item.serialAtribuido">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
                SERIAL: {{ item.serialAtribuido }}
              </span>
              <span class="badge serial serial-pendente" *ngIf="!item.serialAtribuido">SERIAL: não atribuído</span>
              <button class="btn-trocar-serial" (click)="abrirModalTrocarSerial(item, $event)" title="Trocar serial">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>
                Trocar
              </button>
            </div>
            <!-- Form (Lote) atribuído. TIPCONTEST é uma coluna nativa única em TGFPRO
                 (E, L ou N — nunca os dois ao mesmo tempo no mesmo produto). Mas quando
                 um serial é atribuído (SerialRepository), o backend também grava esse
                 mesmo valor em TGFITE.CONTROLE para manter sincronizado — por isso não
                 basta checar "item.controle existe": para não duplicar o SERIAL como se
                 fosse um FORM, só mostra a linha de Form quando o controle for um valor
                 realmente diferente do serial atribuído (Form e Serial genuinamente
                 distintos no mesmo item). -->
            <div class="serial-row" *ngIf="item.tipContest === 'L' || (item.controle && item.controle !== item.serialAtribuido)">
              <span class="badge lote" *ngIf="item.controle && item.controle !== item.serialAtribuido">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path></svg>
                FORM: {{ item.controle }}
              </span>
              <span class="badge lote lote-pendente" *ngIf="!item.controle || item.controle === item.serialAtribuido">FORM: não atribuído</span>
              <button class="btn-trocar-serial btn-trocar-lote" (click)="abrirModalTrocarLote(item, $event)" title="Trocar form">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>
                Trocar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="action-footer">

        <!-- Estado 1: Meus itens concluídos, mas outros separadores ainda trabalhando -->
        <div class="aguardando-outros" *ngIf="meusDone && !allDone">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
          <span>
            Ainda em separação:
            <ng-container *ngFor="let s of separadoresAindaEmSep; let last = last">
              <strong>{{ s.nome }}</strong><span *ngIf="!last">, </span>
            </ng-container>
          </span>
        </div>

        <!-- Estado 2: TODOS concluídos → mostrar quem finalizou + botão -->
        <ng-container *ngIf="allDone">
          <!-- Banner de confirmação -->
          <div class="banner-todos-separados">
            <div class="banner-icone">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            </div>
            <div class="banner-texto">
              <strong>Todos os itens foram separados!</strong>
              <span>Deseja finalizar a separação deste pedido?</span>
            </div>
          </div>

          <div class="outros-finalizaram" *ngIf="separadoresJaFinalizaram.length > 0">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            <span>
              <ng-container *ngFor="let s of separadoresJaFinalizaram; let last = last">
                <strong>{{ s.nome }}</strong><span *ngIf="!last">, </span>
              </ng-container>
              já finaliz{{ separadoresJaFinalizaram.length === 1 ? 'ou' : 'aram' }} também!
            </span>
          </div>
          <button class="btn-concluir" (click)="finalizar()" [disabled]="finalizando">
            <svg *ngIf="!finalizando" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            {{ finalizando ? 'Finalizando...' : 'Finalizar Separação' }}
          </button>
        </ng-container>

        <!-- Erro Finalizar -->
        <div *ngIf="erroFinalizar" class="alert alert-danger" style="margin-top:12px">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
          {{ erroFinalizar }}
        </div>

      </div>

    </div>
  </div>
</div>

<!-- ── MODAL FINALIZAR SEPARAÇÃO (abre ao marcar o último item) ─────────── -->
<div class="modal-overlay" *ngIf="modalFinalizar" (click)="modalFinalizar = false">
  <div class="modal-box modal-finalizar" (click)="$event.stopPropagation()">
    <div class="modal-finalizar-body">
      <div class="modal-finalizar-icone">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
      </div>
      <h2>Todos os itens foram separados!</h2>
      <p>Deseja finalizar a separação deste pedido?</p>
      <div class="modal-finalizar-acoes">
        <button class="btn-cancelar-modal" (click)="modalFinalizar = false">Agora não</button>
        <button class="btn-concluir btn-concluir-modal" (click)="finalizarDoModal()" [disabled]="finalizando">
          <svg *ngIf="!finalizando" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          {{ finalizando ? 'Finalizando...' : 'Finalizar Separação' }}
        </button>
      </div>
      <div *ngIf="erroFinalizar" class="alert alert-danger" style="margin-top:12px">{{ erroFinalizar }}</div>
    </div>
  </div>
</div>

<!-- ── MODAL TRANSFERIR SEPARAÇÃO ─────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalTransferir" (click)="fecharModalTransferir()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Transferir Separação</h2>
      <button class="btn-fechar-modal" (click)="fecharModalTransferir()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>

    <div class="modal-body">
      <p class="modal-desc">
        Selecione o separador que irá continuar esta separação. Após transferir, você não terá mais acesso a este pedido.
      </p>

      <!-- Separador selecionado -->
      <div class="selecionados-list" *ngIf="selecionadoTransferir">
        <div class="chip chip-laranja">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          {{ selecionadoTransferir.nomeusu }}
          <button class="chip-remove" (click)="selecionadoTransferir = null; buscaTransferir = ''">×</button>
        </div>
      </div>

      <!-- Campo de busca -->
      <div class="input-busca-wrap" [class.disabled]="!!selecionadoTransferir">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
        <input
          type="text"
          [(ngModel)]="buscaTransferir"
          (ngModelChange)="onBuscaTransferir()"
          placeholder="Buscar separador pelo nome..."
          [disabled]="!!selecionadoTransferir"
        />
        <app-loading-indicator *ngIf="buscandoTransferir" size="inline"></app-loading-indicator>
      </div>

      <!-- Sugestões -->
      <div class="sugestoes" *ngIf="usuariosTransferir.length > 0">
        <div class="sugestao-item" *ngFor="let u of usuariosTransferir" (click)="selecionarTransferir(u)">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          {{ u.nomeusu }}
        </div>
      </div>

      <div *ngIf="erroTransferir" class="alert alert-danger" style="margin-top:12px">{{ erroTransferir }}</div>
    </div>

    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalTransferir()">Cancelar</button>
      <button class="btn-confirmar-modal btn-confirmar-transferir" (click)="confirmarTransferencia()"
              [disabled]="transferindo || !selecionadoTransferir">
        {{ transferindo ? 'Transferindo...' : 'Confirmar Transferência' }}
      </button>
    </div>
  </div>
</div>

<!-- ── MODAL TROCAR SERIAL ────────────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalTrocarSerial" (click)="fecharModalTrocarSerial()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Trocar Serial</h2>
      <button class="btn-fechar-modal" (click)="fecharModalTrocarSerial()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>

    <div class="modal-body" *ngIf="itemTrocando">
      <p class="modal-desc">
        Produto: <strong>{{ itemTrocando.descricao }}</strong>
      </p>

      <!-- Serial atual -->
      <div class="serial-atual" *ngIf="itemTrocando.serialAtribuido">
        <span class="serial-atual-label">Serial atual:</span>
        <span class="badge serial">{{ itemTrocando.serialAtribuido }}</span>
      </div>
      <div class="serial-atual" *ngIf="!itemTrocando.serialAtribuido">
        <span class="serial-atual-label">Serial atual:</span>
        <span class="badge serial serial-pendente">Não atribuído</span>
      </div>

      <!-- Carregando -->
      <div class="loading-seriais" *ngIf="buscandoSeriais">
        <app-loading-indicator size="inline"></app-loading-indicator>
        <span>Buscando seriais disponíveis...</span>
      </div>

      <!-- Sem seriais disponíveis -->
      <div class="empty-seriais" *ngIf="!buscandoSeriais && serialDisponiveis.length === 0 && !erroTrocar">
        Nenhum serial disponível em estoque para este produto.
      </div>

      <!-- Lista de seriais disponíveis -->
      <div class="seriais-lista" *ngIf="!buscandoSeriais && serialDisponiveis.length > 0">
        <p class="seriais-titulo">Selecione o serial desejado:</p>
        <div
          class="serial-opcao"
          *ngFor="let s of serialDisponiveis"
          [class.serial-opcao-atual]="s.serie === itemTrocando.serialAtribuido"
          (click)="s.serie !== itemTrocando.serialAtribuido && trocarSerial(s.serie)"
        >
          <div class="serial-opcao-info">
            <span class="serial-opcao-num">{{ s.serie }}</span>
            <span class="serial-opcao-fab" *ngIf="s.serieFab">Fab: {{ s.serieFab }}</span>
          </div>
          <span class="serial-opcao-atual-badge" *ngIf="s.serie === itemTrocando.serialAtribuido">Atual</span>
          <svg *ngIf="s.serie !== itemTrocando.serialAtribuido && !trocandoSerial"
               xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
      </div>

      <div *ngIf="erroTrocar" class="alert alert-danger" style="margin-top:12px">{{ erroTrocar }}</div>

      <div class="trocando-overlay" *ngIf="trocandoSerial">
        <app-loading-indicator size="inline"></app-loading-indicator>
        <span>Trocando serial...</span>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalTrocarSerial()" [disabled]="trocandoSerial">Fechar</button>
    </div>
  </div>
</div>

<!-- ── MODAL TROCAR FORM (LOTE) ──────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalTrocarLote" (click)="fecharModalTrocarLote()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Trocar Form</h2>
      <button class="btn-fechar-modal" (click)="fecharModalTrocarLote()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>

    <div class="modal-body" *ngIf="itemTrocandoLote">
      <p class="modal-desc">
        Produto: <strong>{{ itemTrocandoLote.descricao }}</strong>
      </p>

      <!-- Form atual -->
      <div class="serial-atual" *ngIf="itemTrocandoLote.controle">
        <span class="serial-atual-label">Form atual:</span>
        <span class="badge lote">{{ itemTrocandoLote.controle }}</span>
      </div>
      <div class="serial-atual" *ngIf="!itemTrocandoLote.controle">
        <span class="serial-atual-label">Form atual:</span>
        <span class="badge lote lote-pendente">Não atribuído</span>
      </div>

      <!-- Carregando -->
      <div class="loading-seriais" *ngIf="buscandoLotes">
        <app-loading-indicator size="inline"></app-loading-indicator>
        <span>Buscando forms disponíveis...</span>
      </div>

      <!-- Sem forms disponíveis -->
      <div class="empty-seriais" *ngIf="!buscandoLotes && loteDisponiveis.length === 0 && !erroTrocarLote">
        Nenhum form disponível em estoque para este produto.
      </div>

      <!-- Lista de forms disponíveis -->
      <div class="seriais-lista" *ngIf="!buscandoLotes && loteDisponiveis.length > 0">
        <p class="seriais-titulo">Selecione o form desejado:</p>
        <div
          class="serial-opcao"
          *ngFor="let l of loteDisponiveis"
          [class.serial-opcao-atual]="l.controle === itemTrocandoLote.controle"
          (click)="l.controle !== itemTrocandoLote.controle && trocarLote(l.controle, l.codlocal)"
        >
          <div class="serial-opcao-info">
            <span class="serial-opcao-num">{{ l.controle }}</span>
            <span class="serial-opcao-fab">Estoque: {{ l.estoque }}</span>
          </div>
          <span class="serial-opcao-atual-badge" *ngIf="l.controle === itemTrocandoLote.controle">Atual</span>
          <svg *ngIf="l.controle !== itemTrocandoLote.controle && !trocandoLote"
               xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
      </div>

      <div *ngIf="erroTrocarLote" class="alert alert-danger" style="margin-top:12px">{{ erroTrocarLote }}</div>

      <div class="trocando-overlay" *ngIf="trocandoLote">
        <app-loading-indicator size="inline"></app-loading-indicator>
        <span>Alterando form...</span>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalTrocarLote()" [disabled]="trocandoLote">Fechar</button>
    </div>
  </div>
</div>

<!-- ── MODAL DIVIDIR SEPARAÇÃO ──────────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalDividir" (click)="fecharModalDividir()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Dividir Separação</h2>
      <button class="btn-fechar-modal" (click)="fecharModalDividir()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>

    <div class="modal-body">
      <p class="modal-desc">Selecione até 2 separadores adicionais. Os itens serão divididos automaticamente.</p>

      <!-- Chips dos selecionados -->
      <div class="selecionados-list" *ngIf="selecionados.length > 0">
        <div class="chip" *ngFor="let u of selecionados">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          {{ u.nomeusu }}
          <button class="chip-remove" (click)="removerUsuario(u)">×</button>
        </div>
      </div>

      <!-- Campo de busca (desabilitado se já tem 2) -->
      <div class="input-busca-wrap" [class.disabled]="selecionados.length >= 2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
        <input
          type="text"
          [(ngModel)]="buscaUsuario"
          (ngModelChange)="onBuscaUsuario()"
          placeholder="Buscar separador pelo nome..."
          [disabled]="selecionados.length >= 2"
        />
        <app-loading-indicator *ngIf="buscandoUsuarios" size="inline"></app-loading-indicator>
      </div>

      <!-- Lista de sugestões -->
      <div class="sugestoes" *ngIf="usuariosSugeridos.length > 0">
        <div class="sugestao-item" *ngFor="let u of usuariosSugeridos" (click)="adicionarUsuario(u)">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          {{ u.nomeusu }}
        </div>
      </div>

      <div *ngIf="erroDividir" class="alert alert-danger" style="margin-top:12px">{{ erroDividir }}</div>
    </div>

    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalDividir()">Cancelar</button>
      <button class="btn-confirmar-modal" (click)="confirmarDivisao()"
              [disabled]="dividindo || selecionados.length === 0">
        {{ dividindo ? 'Dividindo...' : 'Confirmar Divisão' }}
      </button>
    </div>
  </div>
</div>

<!-- ── MODAL "ITEM NO OUTRO GALPÃO" ─────────────────────────────────────── -->
<!-- Sem identificação de usuário: CODUSU vem da sessão Sankhya já logada. -->
<div class="modal-overlay" *ngIf="modalPendencia" (click)="fecharModalPendencia()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-3px;margin-right:6px"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
        Item no outro Galpão
      </h2>
      <button class="btn-fechar-modal" (click)="fecharModalPendencia()" [disabled]="marcandoPendente">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-desc">
        Este item vai sair da fila "A Separar" sem travar a separação. Alguém confirma na tela global "Itens Pendentes" quando trouxer o item do outro galpão -- aí ele volta pra você conferir/bipar de verdade antes de conseguir finalizar.
      </p>
      <label class="id-label">Observação (opcional)</label>
      <textarea
        class="id-input"
        rows="3"
        style="resize:vertical"
        [(ngModel)]="pendenciaObservacaoRascunho"
        placeholder="Ex.: está no galpão B, prateleira 4"
      ></textarea>
      <div *ngIf="erroPendencia" class="alert alert-danger" style="margin-top:12px">{{ erroPendencia }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalPendencia()" [disabled]="marcandoPendente">Cancelar</button>
      <button class="btn-confirmar-modal" (click)="confirmarPendencia()" [disabled]="marcandoPendente">
        {{ marcandoPendente ? 'Sinalizando...' : 'Confirmar' }}
      </button>
    </div>
  </div>
</div>
